import React from 'react';
import styleable from 'react-styleable';
import PropTypes from 'prop-types';

import Paper from '@material-ui/core/Paper';
import Table from '@material-ui/core/Table';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import TableBody from '@material-ui/core/TableBody';
import { withStyles } from '@material-ui/core/styles';
import TableCell from '@material-ui/core/TableCell';

import css from './index.scss';

import Button from '../../button';

const CustomTableCell = withStyles(theme => ({
    head: {
        backgroundColor: theme.palette.common.black,
        color: theme.palette.common.white,
        fontSize: 14,
        fontFamily: 'poppins'
    },
    body: {
        fontSize: 14,
        fontFamily: 'poppins'
    }
}))(TableCell);

const DisplayTable = ({
    curriculumAlignmentDocuments,
    isRequesting,
    onDeleteFile,
    onDownloadFile
}) => (
    <div className={css.curriculumDocumentsTable}>
        <Paper className={css.root}>
            <Table className={css.table}>
                <colgroup>
                    <col width="18%" />
                    <col width="18%" />
                    <col width="18%" />
                    <col width="18%" />
                    <col width="28%" />
                </colgroup>
                <TableHead>
                    <TableRow>
                        <CustomTableCell>Publication</CustomTableCell>
                        <CustomTableCell>Document</CustomTableCell>
                        <CustomTableCell>Section name</CustomTableCell>
                        <CustomTableCell>Year groups</CustomTableCell>
                        <CustomTableCell>Curriculum alignment docs</CustomTableCell>
                    </TableRow>
                </TableHead>
                <TableBody>
                    <TableRow>
                        <CustomTableCell>
                            {curriculumAlignmentDocuments.publicationName}
                        </CustomTableCell>
                        <CustomTableCell>
                            {curriculumAlignmentDocuments.documentName}
                        </CustomTableCell>
                        <CustomTableCell>
                            {curriculumAlignmentDocuments.sectionName}
                        </CustomTableCell>
                        <CustomTableCell>
                            {curriculumAlignmentDocuments.sectionYearGroups.join(', ')}
                        </CustomTableCell>
                        <CustomTableCell>
                            <div className={css.documentColumn}>
                                {curriculumAlignmentDocuments.alignmentDocumentName}
                                <Button
                                    variant="dark"
                                    label="Delete"
                                    handleOnClick={onDeleteFile}
                                    containerClassName={css.documentButton}
                                    disabled={isRequesting}
                                />
                                <Button
                                    variant="dark"
                                    label="Download"
                                    handleOnClick={onDownloadFile}
                                    containerClassName={css.documentButton}
                                    disabled={isRequesting}
                                />
                            </div>
                        </CustomTableCell>
                    </TableRow>
                </TableBody>
            </Table>
        </Paper>
    </div>
);

DisplayTable.propTypes = {
    curriculumAlignmentDocuments: PropTypes.object,
    isRequesting: PropTypes.bool,
    onDeleteFile: PropTypes.func,
    onDownloadFile: PropTypes.func
};

export default styleable(css)(DisplayTable);



// WEBPACK FOOTER //
// ./app/components/curriculum-documents/display-table/index.js